import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar, } from '@mui/material';
import { callApi } from '../../pages/commonapicall/fetchdata';
import { tokens } from '../../theme/theme';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { API_ENDPOINTS } from '../../config/api/apiCall';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import CallAlertBar from '../../Layout/Alertbar';

import {
  Table,
  TableBody,
  Autocomplete,
  TableCell,
  Grid,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  TextField,

  useTheme,
  CssBaseline,
  
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Select,
  MenuItem,
  InputLabel,
  IconButton,
  Tooltip,
  FormControl,
  Typography,
  
  alpha
} from '@mui/material';
import { useNavigate } from "react-router-dom";
import {  Delete, Close } from '@mui/icons-material';
import { InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useParams } from "react-router-dom";
import dayjs from 'dayjs';
import CustomTableContainer from '../../components/table/CustomTableContainer';
import ResponsiveBox from '../../components/form/ResponsiveScrollBox';
import SkeletonTableLoader from '../../components/table/SkeletonTableLoader';
import TableFilterRow from '../../components/table/TableFilterRow';
import CustomPagination from '../../components/table/CustomPagination';



const UserList = () => {

  const { CompanyId } = useParams();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [newUser, setNewUser] = useState({ userid: '', department: '', password: '', roles: '', isactive: 'true' });
  const [currentUserId, setCurrentUserId] = useState(null);
  const [errorMessages, setErrorMessages] = useState({});
  const theme = useTheme();
  const navigate = useNavigate();
  const colors = tokens(theme.palette.mode);
  const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
  const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
  const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
  const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

  const [user, setUser] = useState([]);
  const [userRoles, setUserRoles] = useState([]);

  const [employee, setEmployee] = useState('');
  const [employeelist, setEmployeelist] = useState([]);

  const [employeeID, setEmployeeID] = useState(0);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = { p_companyid: localStorage.getItem('companyid') };

    callApi(API_ENDPOINTS.EMPLOYEE_GetEmployeeLists, 'POST', { 'Content-Type': 'application/json' }, params)
      .then(data => {
        if (data?.length) {
          setEmployeelist(data);
        }
      })
      .catch(error => alert(error.message));
  }, []);


  const handleEmployeeChange = (event, value) => {
    if (value) {
      setEmployee(value);
      setEmployeeID(value.id);
    }
    else {
      setEmployee('');
      setEmployeeID(0);
    }
  }

  const handleLoadUserDetails = () => {
    let requestBody = {
      CompanyId: CompanyId,
    };
    setLoading(true);

    callApi(API_ENDPOINTS.USER_getUserDataByCompanyID, 'POST', { 'Content-Type': 'application/json' }, requestBody)
      .then(data => {
        // Update state with fetched data

        if (data.length > 0) {
          // setUser(data);
          const formattedData = data.map(user => ({
            ...user,
            createddate: dayjs(user.createddate).format('DD-MMM-YYYY hh:mm A'), // Format created date
            lastlogintimestamp: user.lastlogintimestamp === '0001-01-01T00:00:00'
              ? ''
              : dayjs(user.lastlogintimestamp).format('DD-MMM-YYYY hh:mm A'),
            lastlogouttimestamp: user.lastlogouttimestamp === '0001-01-01T00:00:00'
              ? ''
              : dayjs(user.lastlogouttimestamp).format('DD-MMM-YYYY hh:mm A')
          }));
          setUser(formattedData);
          setLoading(false);
        }
        else {
          setParentRollSeverityvalue('warning');
          setParentRollMessageValue('No user data found..!');
          setParentRollAlertTitleValue('Warning');
          setParentRollMsgOpen(true);
          setLoading(false);
        }
      })
      .catch(error => {
        // // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue('Unable to load the user details');
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
        setLoading(false);
      });
  };

  const LoadRoleList = () => {
    let requestBody = {
      CompanyId: CompanyId,
    };

    callApi(API_ENDPOINTS.USER_getUserRoles, 'POST', { 'Content-Type': 'application/json' }, requestBody)
      .then(data => {
        // Update state with fetched data

        if (data.length > 0) {
          setUserRoles(data);
        }
        else {
          setParentRollSeverityvalue('warning');
          setParentRollMessageValue('No user roles data found..!');
          setParentRollAlertTitleValue('Warning');
          setParentRollMsgOpen(true);
        }
      })
      .catch(error => {
        // // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue('Unable to load user role details');
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
      });
  };

  useEffect(() => {
    handleLoadUserDetails();
    LoadRoleList();
  }, []);



  const handleEditUserDetails = (user) => {
    setNewUser(user);
    setCurrentUserId(user.id);
    setIsEditModalOpen(true);

    // Set selectedRoles based on the user's roles
    const userAssignedRoles = user.roles.split(", "); // Assuming roles are a comma-separated string
    const selected = userRoles.filter(role => userAssignedRoles.includes(role.role_name)); // Match roles
    setSelectedRoles(selected); // Update selectedRoles state

    // Set employee
    if (user.id_employee !== 0) {
      const emp = employeelist.find(e => e.id === user.id_employee);
      setEmployee(emp);
      setEmployeeID(emp.id);
    }
    else {
      setEmployee('');
      setEmployeeID(0);
    }
  }

  const handleDeleteUser = (user) => {

    if (window.confirm(`Are you sure you want to delete this user (${user.userid}) ?`)) {
      let requestBody = {
        CompanyId: CompanyId,
        userid: user.userid,
      };
      setLoading(true);
      callApi(API_ENDPOINTS.USER_deleteUserDetails, 'POST', { 'Content-Type': 'application/json' }, requestBody)
        .then(data => {
          // Update state with fetched data

          if (data.length > 0) {
            setParentRollSeverityvalue('info');
            setParentRollMessageValue(data);
            setParentRollAlertTitleValue('Info');
            setParentRollMsgOpen(true);
            handleLoadUserDetails();
            setLoading(false);
          }
          else {
            setParentRollSeverityvalue('error');
            setParentRollMessageValue('Unable to delete the user');
            setParentRollAlertTitleValue('Error');
            setParentRollMsgOpen(true);
            setLoading(false);
          }

        })
        .catch(error => {
          // // Update state with error message        
          setParentRollSeverityvalue('error');
          setParentRollMessageValue(error.message);
          setParentRollAlertTitleValue('Error');
          setParentRollMsgOpen(true);
          setLoading(false);
        });
    }




  }

  // Function to handle adding a new user
  const handleAddUser = () => {
    const errors = validateUser(newUser);

    if (Object.keys(errors).length > 0) {
      setErrorMessages(errors);
      return;
    }



    //selectedRoles
    let requestBody = {
      CompanyId: CompanyId,
      userid: newUser.userid,
      password: newUser.password,
      username: newUser.userid,
      department: newUser.department,
      isactive: newUser.isactive,
      lastupdatedby: '',
      RoleIds: selectedRoles.map(role => role.role_id),
      id_employee: employeeID

    };
    setLoading(true);

    callApi(API_ENDPOINTS.USER_insertUpdateUserDetails, 'POST', { 'Content-Type': 'application/json' }, requestBody)
      .then(data => {
        // Update state with fetched data

        if (data.length > 0) {
          setParentRollSeverityvalue('info');
          setParentRollMessageValue(data);
          setParentRollAlertTitleValue('Info');
          setParentRollMsgOpen(true);
          handleLoadUserDetails();
          setLoading(false);
        }
        else {
          setParentRollSeverityvalue('error');
          setParentRollMessageValue(data);
          setParentRollAlertTitleValue('Error');
          setParentRollMsgOpen(true);
          setLoading(false);
        }



        // const updatedUsers = [
        //   ...users,
        //   { ...newUser, id: users.length + 1 }, // Assign a new ID
        // ];
        // setUsers(updatedUsers);
        resetForm();

      })
      .catch(error => {
        // // Update state with error message        
        setParentRollSeverityvalue('error');
        setParentRollMessageValue(error.message);
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
        setLoading(false);
      });


  };

  const [selectedRoles, setSelectedRoles] = useState([]);
  const handleRoleChange = (event, value) => {
    setSelectedRoles(value);
  };




  // Function to validate user input
  const validateUser = (user) => {
    const errors = {};
    if (!user.userid) {
      errors.userid = "Username is required.";
    } else if (!/\S+@\S+\.\S+/.test(user.userid)) {
      errors.userid = "Username is invalid.";
    }
    if (!user.password) errors.password = "Password is required.";

    if (selectedRoles.length === 0) errors.role = "Role is required.";
    if (!user.department) errors.department = "Department is required.";
    return errors;
  };

  // Function to reset the form
  const resetForm = () => {
    setIsModalOpen(false);
    setIsEditModalOpen(false);
    setNewUser({ department: '', password: '', userid: '', role: '', isactive: 'true' });
    setCurrentUserId(null);
    setErrorMessages({});
  };


  const handleBackToCompany = () => {
    navigate("/CompanyManagement");
  }

  const handleOpenRolemanagement = () => {
    const url = `/RoleManagement/${CompanyId}`;
    //const url = `/newordercreate/${IndentId}/${ConfirmationOrderId}`;
    navigate(url);
  };

  const handleCreateNewUser = () => {
    setIsModalOpen(true);
    setEmployee('');
    setEmployeeID(0);

  };

  const handleOpenUserModulePermissions = () => {
    const url = `/AssignPermissions/${CompanyId}`;
    //const url = `/newordercreate/${IndentId}/${ConfirmationOrderId}`;
    navigate(url);
  };

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault(); // Prevents focusing on the button when clicked
  };



  const [recordsPerPage, setRecordsPerPage] = useState(20); // Records per page

  useEffect(() => {
    const handleResize = () => {
      const screenHeight = window.innerHeight;
      const estimatedItemHeight = 60; // height of one record/item in pixels, adjust as needed
      const calculatedRecords = Math.floor(screenHeight / estimatedItemHeight);
      setRecordsPerPage(calculatedRecords);
    };

    // Initial calculation
    handleResize();

    // Recalculate on window resize
    window.addEventListener('resize', handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    userid: '',
    roles: '',
    department: '',
    isactive: '',
    createddate: '',
    loggedin: '',
    lastlogintimestamp: '',
    lastlogouttimestamp: '',


  });
  const [selectedStatus, setSelectedStatus] = useState('All');

  const filteredData = user.filter((row) => {
    // Check if row matches selected status
    if (selectedStatus === 'All' || row.status === selectedStatus) {
      // Check if all filter fields match
      return Object.keys(filters).every((key) => {
        if (filters[key] === '') return true; // No filter applied
        return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
      });
    }
    return false;
  });


  const handleFilterChange = (e, column) => {
    setFilters({ ...filters, [column]: e.target.value });
  };


  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };


  const pageCount = Math.ceil(filteredData.length / recordsPerPage);

  const uniqueValues = {
    userid: [...new Set(user.map(row => row.userid))],
    roles: [...new Set(user.map(row => row.roles))],
    department: [...new Set(user.map(row => row.department))],
   
 
  };


  // Get the records for the current page
  const currentRecords = filteredData.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage
  );

  const columns = ['userid', 'roles', 'department', 'isactive', 'createddate', 'loggedin', 'lastlogintimestamp', 'lastlogouttimestamp'];

  const autoCompleteColumns = ['userid', 'roles', 'department'];


  return (
    <Grid container padding={1} spacing={1}>



      <CssBaseline />

      <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
        <Toolbar>
          {/* First Menu */}

          <Typography variant="h4"  sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}>
            User Management 
          </Typography>

          {/* <Header title="User Management"  callback={handleBackToCompany}/> */}


          {/* Adding margin-left: auto to push the button to the right */}
          <Button
            size="small"
            variant="contained"
            onClick={handleCreateNewUser}
            color="secondary"
            startIcon={<PersonAddAltIcon />}
            sx={{
              marginLeft: 'auto',
              textTransform: 'none',

            }}
          >
            New User
          </Button>


          <Button size="small" variant="outlined" sx={{ ml: 1, textTransform: 'none' }} onClick={handleOpenRolemanagement} startIcon={<AccessibilityIcon />} color="secondary">User Roles</Button>
          <Button size="small" variant="outlined" sx={{ ml: 1, textTransform: 'none' }} onClick={handleOpenUserModulePermissions} startIcon={<VerifiedUserIcon />} color="secondary">Role Permissons</Button>



          <IconButton onClick={handleBackToCompany} >
            <Close style={{ fontSize: "16px", color: "#2196F3" }} />
          </IconButton>




        </Toolbar>
      </AppBar>

      <CallAlertBar
        parentRollMsgOpen={parentRollMsgOpen}
        setParentRollMsgOpen={setParentRollMsgOpen}
        parentRollSeverityvalue={parentRollSeverityvalue}
        setParentRollSeverityvalue={setParentRollSeverityvalue}
        parentRollAlertTitleValue={parentRollAlertTitleValue}
        setParentRollAlertTitleValue={setParentRollAlertTitleValue}
        parentRollMessageValue={parentRollMessageValue}
        setParentRollMessageValue={setParentRollMessageValue}
      />



      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <ResponsiveBox colors={colors} customMaxHeight={{
          xs: '72vh', // Extra small devices (phones)
          sm: '72vh', // Small devices (tablets)
          md: '74vh', // Medium devices (small laptops)
          lg: '82vh', // Large devices (desktops)
          xl: '86vh', // Extra large devices (large desktops)
        }}>
          <CustomTableContainer colors={colors}>
            <TableContainer>
              {loading ? (
                <SkeletonTableLoader rows={5} columns={11} />
              ) : (

                <Table size="small">
                  <TableHead sx={{ backgroundColor: colors.primary[400] }}>
                    <TableRow >
                      <TableCell >USER NAME - (EMAIL)</TableCell>
                      <TableCell >ROLES</TableCell>
                      <TableCell>DEPARTMENT</TableCell>
                      <TableCell>STATUS</TableCell>
                      <TableCell>CREATED ON</TableCell>
                      <TableCell sx={{ textAlign: "center", minWidth: 120, whiteSpace: "nowrap" }}>LOGGED IN NOW?</TableCell>
                      <TableCell>LAST LOGGED IN</TableCell>
                      <TableCell>LAST LOGGED OUT</TableCell>
                      <TableCell></TableCell>
                    </TableRow>

                    <TableFilterRow
                      columns={columns}
                      filters={filters}
                      handleFilterChange={handleFilterChange}
                      uniqueValues={uniqueValues}
                      autoCompleteColumns={autoCompleteColumns}
                    />
                  </TableHead>
                  <TableBody>
                    {currentRecords.map((user, index) => (


                      <TableRow key={user.id} sx={{
                        backgroundColor:
                          index % 2 === 0
                            ? theme.palette.background.default
                            : alpha(theme.palette.action.hover, 0.04), // slightly darker
                      }}>



                        <TableCell>
                          <span
                            style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                            onClick={() => handleEditUserDetails(user)}
                          >
                            {user.userid}
                          </span>
                        </TableCell>

                        <TableCell >{user.roles}</TableCell>
                        <TableCell >{user.department}</TableCell>
                        <TableCell>{user.isactive ? 'Active' : 'Inactive'}</TableCell>
                        <TableCell >{user.createddate}</TableCell>
                        <TableCell>
                          <Checkbox
                            size='small'
                            checked={user.loggedin} // checked if `loggedin` is true
                            disabled // disable the checkbox to make it read-only
                            color="secondary"
                          />
                        </TableCell>
                        <TableCell >{user.lastlogintimestamp}</TableCell>
                        <TableCell >{user.lastlogouttimestamp}</TableCell>

                        <TableCell>
                          <Tooltip title="Delete User" >
                            <IconButton
                              color="secondary"
                              size='small'
                              onClick={() => {
                                handleDeleteUser(user)
                              }}
                            >
                              <Delete fontSize='14px' />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </TableContainer>

          </CustomTableContainer>

        </ResponsiveBox>
        <CustomPagination pageCount={pageCount} currentPage={currentPage} onPageChange={handlePageChange} />
      </Grid>

      {/* Add User Dialog */}
      <Dialog open={isModalOpen} onClose={resetForm}>
        <DialogTitle style={{ backgroundColor: theme.palette.background.default }}>Add User</DialogTitle>
        <DialogContent style={{ backgroundColor: theme.palette.background.default }}>

          <TextField
            margin="dense"
            label="Username"
            size='small'
            type="email"
            fullWidth
            variant="outlined"
            value={newUser.userid}
            onChange={(e) => setNewUser({ ...newUser, userid: e.target.value })}
            required
            error={!!errorMessages.userid}
            helperText={errorMessages.userid}
          />

          <TextField
            margin="dense"
            label="Password"
            size="small"
            type={showPassword ? 'text' : 'password'}  // Toggle between 'text' and 'password'
            fullWidth
            variant="outlined"
            value={newUser.password}
            onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
            required
            error={!!errorMessages.password}
            helperText={errorMessages.password}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <FormControl fullWidth margin="dense" size='small'>
            <Autocomplete
              multiple
              options={userRoles}
              getOptionLabel={(role) => role.role_name}
              onChange={handleRoleChange}
              size='small'
              renderInput={(params) => <TextField  {...params} label="Roles" variant="outlined" />}
            />
          </FormControl>


          <FormControl fullWidth margin="dense" size='small' error={!!errorMessages.department}>
            <InputLabel>Department</InputLabel>
            <Select
              value={newUser.department}
              onChange={(e) => setNewUser({ ...newUser, department: e.target.value })}
              required
            >
              <MenuItem value=""><em>Select department</em></MenuItem>
              <MenuItem value="Admin">Admin</MenuItem>
              <MenuItem value="Sales">Sales</MenuItem>
              <MenuItem value="Purchase">Purchase</MenuItem>
              <MenuItem value="Production">Production</MenuItem>
            </Select>
            {errorMessages.department && <Typography variant="caption" color="error">{errorMessages.department}</Typography>}
          </FormControl>


          <FormControl fullWidth margin="dense" size='small'>
            <InputLabel>Status</InputLabel>
            <Select
              value={newUser.isactive}
              onChange={(e) => setNewUser({ ...newUser, isactive: e.target.value })}
            >
              <MenuItem value="true">Active</MenuItem>
              <MenuItem value="false">Inactive</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth margin="dense" size='small'>
            <Autocomplete
              fullWidth
              value={employee}
              onChange={handleEmployeeChange}
              size="small"
              label="Select the Employee"
              options={employeelist}
              getOptionLabel={(option) => option?.name || ''}

              renderInput={(params) =>
                <TextField
                  label="Select the Employee"
                  {...params} variant="outlined" />}
            />
          </FormControl>


        </DialogContent>




        <DialogActions style={{ backgroundColor: theme.palette.background.default }}>
          <Button onClick={resetForm} sx={{ textTransform: 'none' }} size='small' variant='outlined' color="secondary">
            Cancel
          </Button>
          <Button onClick={handleAddUser} sx={{ textTransform: 'none' }} size='small' variant='contained' color="secondary">
            Save
          </Button>
        </DialogActions>
      </Dialog>


      {/*  Edit User Dialog */}
      <Dialog open={isEditModalOpen} onClose={resetForm}>
        <DialogTitle style={{ backgroundColor: theme.palette.background.default }}>Edit User</DialogTitle>
        <DialogContent style={{ backgroundColor: theme.palette.background.default }}>


          <TextField
            margin="dense"
            label="Username"
            size='small'
            type="email"
            disabled
            fullWidth
            variant="outlined"
            value={newUser.userid}
            onChange={(e) => setNewUser({ ...newUser, userid: e.target.value })}
            required
            error={!!errorMessages.userid}
            helperText={errorMessages.userid}
          />


          <TextField
            margin="dense"
            label="Password"
            
            type={showPassword ? 'text' : 'password'}  // Toggle between 'text' and 'password'
            size="small"
            fullWidth
            variant="outlined"
            value={newUser.password}
            onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
            required
            error={!!errorMessages.password}
            helperText={errorMessages.password}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <FormControl fullWidth margin="dense" size='small' error={!!errorMessages.role}>
            {/* <FormControl fullWidth margin="dense" size='small'> */}
            <Autocomplete
              multiple
              options={userRoles}
              getOptionLabel={(role) => role.role_name}
              onChange={handleRoleChange}
              value={selectedRoles}  // Bind selectedRoles state to Autocomplete
              size='small'
              renderInput={(params) => <TextField  {...params} label="Roles" variant="outlined" />}
            />
            {errorMessages.role && <Typography variant="caption" color="error">{errorMessages.role}</Typography>}

          </FormControl>

          <FormControl fullWidth margin="dense" size='small' error={!!errorMessages.department}>
            <InputLabel>Department</InputLabel>
            <Select
              value={newUser.department}
              onChange={(e) => setNewUser({ ...newUser, department: e.target.value })}
              required
            >
              <MenuItem value=""><em>Select Department</em></MenuItem>
              <MenuItem value="Admin">Admin</MenuItem>
              <MenuItem value="Sales">Sales</MenuItem>
              <MenuItem value="Purchase">Purchase</MenuItem>
              <MenuItem value="Production">Production</MenuItem>
            </Select>
            {errorMessages.department && <Typography variant="caption" color="error">{errorMessages.department}</Typography>}
          </FormControl>





          <FormControl fullWidth margin="dense" size='small'>
            <InputLabel>Status</InputLabel>
            <Select
              value={newUser.isactive}
              onChange={(e) => setNewUser({ ...newUser, isactive: e.target.value })}
            >
              <MenuItem value="true">Active</MenuItem>
              <MenuItem value="false">Inactive</MenuItem>
            </Select>
          </FormControl>


          <FormControl fullWidth margin="dense" size='small'>
            <Autocomplete
              fullWidth
              value={employee}
              onChange={handleEmployeeChange}
              size="small"
              label="Select the Employee"
              options={employeelist}
              getOptionLabel={(option) => option?.name || ''}
              renderInput={(params) =>
                <TextField
                  label="Select the Employee"
                  {...params} variant="outlined" />}
            />
          </FormControl>

        </DialogContent>
        <DialogActions style={{ backgroundColor: theme.palette.background.default }}>
          <Button onClick={resetForm} size='small' sx={{ textTransform: 'none' }} color="secondary" variant='outlined'>
            Cancel
          </Button>
          <Button onClick={handleAddUser} size='small' sx={{ textTransform: 'none' }} color="secondary" variant='contained'>
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default UserList;
